import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { fetchHotJobs, IGlobalJobDTO, IGlobalJobSearchFilterDTO } from 'wisestep-api';

const useHotJobsListing = (
  query: IGlobalJobSearchFilterDTO,
  setLoader: Dispatch<SetStateAction<boolean>>
): [(IGlobalJobDTO & { isSelected: boolean })[], number] => {
  const [hotJobsArr, setHotJobsArr] = useState<(IGlobalJobDTO & { isSelected: boolean })[]>([]);
  const [pagesCount, setCount] = useState(0);

  useEffect(() => {
    const hotJobs = async () => {
      try {
        setLoader(true);
        const response = await fetchHotJobs(query);
        setCount(Number(response.headers['x-total-count']));
        setHotJobsArr(response.data);
        setLoader(false);
      } catch (e) {
        console.log(e);
        setLoader(false);
      }
    };

    hotJobs();
  }, [query, setLoader]);

  return [hotJobsArr, pagesCount];
};

export default useHotJobsListing;
